var styles = {"box":"Row_box_17z7l_1","v2":"Row_v2_17z7l_7","margin":"Row_margin_17z7l_10","padding":"Row_padding_17z7l_14","padding-top-sm":"Row_padding-top-sm_17z7l_17","no-top-padding":"Row_no-top-padding_17z7l_20","no-bottom-padding":"Row_no-bottom-padding_17z7l_23","container":"Row_container_17z7l_43"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
